  // SHOW INFO NEWSLETTER
(function($){
  var form = jQuery('.contact-form');
  var inputEmail = form.find('input[type=email]');
  var info = form.find('.form_info');
  var checkbox = info.find('.accept_checkbox');
  var button = form.find('button[type=submit]');
  button.attr( 'disabled', true );
  inputEmail.on('input', function(){
      info.show(300);
  });
  checkbox.change(function(){
      if(this.checked){
          button.removeAttr('disabled');
      }else{
          button.attr( 'disabled', true );
      }
  });
  jQuery(document).mouseup(function (e) {
      if ( form.has(e.target).length === 0 ){
          button.attr( 'disabled', true );
          checkbox.removeAttr('checked');
          info.hide(300);
      };
  });
})(jQuery);